import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { useQueryNoFurtherUpdateInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryNoFurtherUpdateInterop.ts';
import { ATL_PAGE_CONTENT_FOOTER_ACTIONS } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { WebPanelLocationQuery } from '@confluence/web-panel-location/entry-points/WebPanelLocationQuery.ts';
import type {
	WebPanelLocationQueryData,
	WebPanelLocationQueryVariables,
} from '@confluence/web-panel-location/entry-points/WebPanelLocationQueryArtifacts.ts';
import { usePathnameMatcher } from '@confluence/route-manager/entry-points/RouteState.ts';

export const useIsReactionsEnabled = (contentId: string): boolean => {
	const isPDFExport = usePathnameMatcher({
		selector: (pathname) => pathname?.indexOf('/wiki/pdf/') !== -1,
	});

	const baseOptions = {
		variables: {
			contentId,
			location: ATL_PAGE_CONTENT_FOOTER_ACTIONS,
		},
		skip: isPDFExport,
	};

	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data } = expValEquals('confluence_stop_watching_webpanellocationquery', 'isEnabled', true)
		? // eslint-disable-next-line react-hooks/rules-of-hooks
			useQueryNoFurtherUpdateInterop<WebPanelLocationQueryData, WebPanelLocationQueryVariables>(
				WebPanelLocationQuery,
				baseOptions,
			)
		: // eslint-disable-next-line react-hooks/rules-of-hooks
			useQueryInterop<WebPanelLocationQueryData, WebPanelLocationQueryVariables>(
				// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
				WebPanelLocationQuery,
				{
					...baseOptions,
					fetchPolicy: 'cache-first' as const,
				},
			);

	return !isPDFExport && Boolean(data?.webPanels?.length);
};
